import { PageDataType } from '@common/paged-data/enums/page-data-type.enum';
import { GridColumn } from '@portal-core/ui/grid/models/grid-column.model';
import { PageFilterConfigBase } from '@portal-core/ui/page-filters/util/page-filter-config-base';

export class BuildPageFilterConfig extends PageFilterConfigBase {
  static readonly Columns: GridColumn[] = [
    {
      name: 'Id',
      title: 'ID',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Int
    },
    {
      name: 'BranchName',
      title: 'Branch',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.String,
    },
    {
      name: 'TargetPath',
      title: 'Target',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.String
    },
    {
      name: 'Description',
      title: 'Description',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.String
    },
    {
      name: 'Project.LicenseId',
      title: 'License Id',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Int,
    },
    {
      name: 'Project.Name',
      title: 'Project',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.String,
    },
    {
      name: 'IsKept',
      title: 'Keep',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Select,
      filterDataType: PageDataType.Boolean,
      selectOptions: [{ id: 'false', text: 'None' }, { id: 'true', text: 'Kept' }]
    },
    {
      name: 'Process.LastProcessAttempt.CreatedOn',
      title: 'Started',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Date,
    },
    {
      name: 'Process.LastProcessAttempt.EndedOn',
      title: 'Finished',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Date
    },
    {
      name: 'RanFor',
      title: 'Duration',
      type: PageDataType.Int
    },
    {
      // Filter/sort by the latest ProcessAttempt's Status. Values are ProcessAttemptStatus
      // enum integers (Queued=0, Running=1, Complete=2, Failed=3, Aborted=4, Canceled=5).
      // The "Running" bucket covers every non-terminal-non-queued state — surfaces formerly
      // shown as GettingFiles/Building/Publishing collapse to a single user-facing "Running".
      name: 'Process.LastProcessAttempt.Status',
      title: 'State',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Select,
      selectOptions: [{ id: '2', text: 'Complete' }, { id: '3', text: 'Failed' }, { id: '5', text: 'Canceled' }, { id: '4', text: 'Aborted' }, { id: '0', text: 'Queued' }, { id: '1', text: 'Running' }]
    },
    {
      name: 'ProgressValue',
      title: 'Progress',
      type: PageDataType.Int
    },
    {
      name: 'Process.CreatedByUser.FullName',
      title: 'By',
      filterEnabled: true,
      type: PageDataType.String,
      filterDataType: PageDataType.FullName
    },
    {
      name: 'Process.LastProcessAttempt.WarningCount',
      title: 'Warnings',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Int
    },
    {
      name: 'Process.LastProcessAttempt.ErrorCount',
      title: 'Errors',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Int
    },
    {
      name: 'CreatedOn',
      title: 'Queued',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Date
    },
    {
      name: 'IsBuiltOnCentral',
      title: 'Source',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Select,
      selectOptions: [{ id: '0', text: 'Flare Desktop' }, { id: '1', text: 'Flare Online' }]
    },
    {
      name: 'CommitId',
      title: 'Commit',
      filterEnabled: true,
      type: PageDataType.String
    },
    {
      name: 'AzureStorageSize',
      title: 'Size',
      filterEnabled: true,
      sortEnabled: true,
      type: PageDataType.Int
    }
  ];

  constructor(enabledColumnNames?: string[]) {
    super(enabledColumnNames, BuildPageFilterConfig.Columns);
  }
}
